import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { menu } from "../app/schema";

export const GET_MENUS = "GET_MENUS";
export const GET_MENUS_SUCCESS = "GET_MENUS_SUCCESS";
export const GET_MENUS_ERROR = "GET_MENUS_ERROR";

export const GET_MENU = "GET_MENU";
export const GET_MENU_SUCCESS = "GET_MENU_SUCCESS";
export const GET_MENU_ERROR = "GET_MENU_ERROR";

export const PATCH_MENU = "PATCH_MENU";
export const PATCH_MENU_SUCCESS = "PATCH_MENU_SUCCESS";
export const PATCH_MENU_ERROR = "PATCH_MENU_ERROR";

export const DELETE_MENU = "DELETE_MENU";
export const DELETE_MENU_SUCCESS = "DELETE_MENU_SUCCESS";
export const DELETE_MENU_ERROR = "DELETE_MENU_ERROR";

export const SET_IS_EDIT_MENU_ITEM_MODAL_VISIBLE = "SET_IS_EDIT_MENU_ITEM_MODAL_VISIBLE";
export const SET_IS_REMOVE_MENU_ITEM_MODAL_VISIBLE = "SET_IS_REMOVE_MENU_ITEM_MODAL_VISIBLE";

// Requests
const getMenusGet = (fetch, apiHost, accessToken, meta) =>
  fetch(
    `${apiHost}/v1/menus?limit=${meta.limit}&offset=${meta.currentPage *
      meta.limit}`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      method: "GET"
    }
  ).then(response => {
    return validateResponse(response, {});
  });

const getMenuGet = (fetch, apiHost, accessToken, placeholder) =>
  fetch(`${apiHost}/v1/menu/${placeholder}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const patchMenu = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/menus/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

const deleteMenu = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/menus/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg: "Nie można usunąć danych kategorii, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

// Actions
export function getMenus(meta) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_MENUS],
    payload: {
      promise: getMenusGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        meta
      )
        .then(data => {
          return normalize(data, { menus: arrayOf(menu) });
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function getMenu(placeholder) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_MENU],
    payload: {
      promise: getMenuGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        placeholder
      )
        .then(data => {
          return normalize(data, menu);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function updateMenu(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_MENU],
    payload: {
      promise: patchMenu(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, menu);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removeMenu(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_MENU],
    payload: {
      promise: deleteMenu(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

export function setIsEditMenuModalVisible(value) {
  return {
    type: SET_IS_EDIT_MENU_ITEM_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

export function setIsRemoveMenuModalVisible(value) {
  return {
    type: SET_IS_REMOVE_MENU_ITEM_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/menus/actions.js